module.exports = "<div id=\"dmi-form-body\"></div>"